import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const listSettings = () => {
  return apiService.callExternalApi<{ key: string; active: boolean }[]>({
    url: `${API_SERVER_URL}/settings`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const updateSettingData = (settingData: { key: string; active: boolean }) => {
  return apiService.callExternalApi<{ key: string; active: boolean }>({
    url: `${API_SERVER_URL}/settings/${settingData.key}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: settingData
  });
};
